import api from './api';
import { PaymentResponse } from '../types';

export const initializePayment = async (
    plan: string,
    billingCycle: string
): Promise<PaymentResponse> => {
    const response = await api.post(`/api/payment/initialize/${plan}/${billingCycle}`);
    return response.data;
};

// export const initializePayment = async (
//     plan: string
// ): Promise<PaymentResponse> => {
//     const response = await api.post(`/api/payment/initialize/${plan}`);
//     return response.data;
// };

export const verifyPayment = async (reference: string): Promise<string> => {
    const response = await api.get(`/api/payment/verify/${reference}`);
    return response.data;
};